"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormatToQueryString = exports.RESOURCE_DATE_FORMAT = void 0;
exports.RESOURCE_DATE_FORMAT = {
    ISO8601: 'iso8601',
    UTC: 'utc',
};
/**
 * @description
 * Convert the sort options for Query into a query string
 *
 * @param sorts
 */
function dateFormatToQueryString(dateFormat) {
    const queryParamsObject = {
        dateFormat,
    };
    return queryParamsObject;
}
exports.dateFormatToQueryString = dateFormatToQueryString;
